import { Button, TableCell, TableRow, Typography, Stack } from '@mui/material';
import { Api } from '../../api';
import { PencilSimple } from '@phosphor-icons/react';
import { format } from 'date-fns';

type Props = {
  feedback: Api.Feedback.UserV_ListAsAdmin;
  onEditNote: (feedback: Api.Feedback.UserV_ListAsAdmin) => void;
  onAddNote: (feedback: Api.Feedback.UserV_ListAsAdmin) => void;
};

export default function UserFeedbackRow({
  feedback,
  onEditNote,
  onAddNote,
}: Props) {
  const getCategoryLabel = (category: string) => {
    switch (category) {
      case 'technical-issue':
        return 'Technical Issue';
      case 'feature-idea':
        return 'Feature Idea';
      default:
        return 'Other';
    }
  };

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2" sx={{ maxWidth: 400 }}>
          {feedback.message}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {getCategoryLabel(feedback.category)}
        </Typography>
      </TableCell>
      <TableCell>{feedback.user.name ?? '-'}</TableCell>
      <TableCell>{feedback.user.email}</TableCell>
      <TableCell>
        {format(new Date(feedback.submittedAt), 'd MMM yyyy')}
      </TableCell>
      <TableCell>
        <Stack spacing={1}>
          {feedback.adminNote && (
            <Typography variant="body2" sx={{ maxWidth: 200 }}>
              {feedback.adminNote.length > 50
                ? `${feedback.adminNote.substring(0, 50)}...`
                : feedback.adminNote}
            </Typography>
          )}
          <Button
            variant="text"
            size="small"
            onClick={() =>
              feedback.adminNote ? onEditNote(feedback) : onAddNote(feedback)
            }
            sx={{ alignSelf: 'flex-start' }}
            startIcon={<PencilSimple size={16} />}
          >
            {feedback.adminNote ? 'Edit' : 'Add Note'}
          </Button>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
